import { createContext, useContext, useMemo } from 'react'
import { createLocalStorageSync } from './hooks/use-local-storage-sync'
import type { ScopeFilter } from './utils'

type ScopeContextValue = {
  scope: ScopeFilter
  setScope: (s: ScopeFilter) => void
}

export const ScopeContext = createContext<ScopeContextValue | null>(null)

const useScopeStorage = createLocalStorageSync<ScopeFilter>(
  'scope-preference',
  'all',
  (raw) => (raw === 'all' || raw === 'household' || raw === 'personal' ? raw : null),
)

export function ScopeProvider({ children }: { children: React.ReactNode }) {
  const [scope, setScope] = useScopeStorage()

  const value = useMemo<ScopeContextValue>(
    () => ({ scope, setScope }),
    [scope, setScope],
  )

  return (
    <ScopeContext.Provider value={value}>
      {children}
    </ScopeContext.Provider>
  )
}

export function useScope(): ScopeContextValue {
  const ctx = useContext(ScopeContext)
  if (!ctx) throw new Error('useScope must be used within ScopeProvider')
  return ctx
}
